import { useState } from "react";
import { Box } from "@mui/material";
import IntraoralFindingTab from "./IntraoralFindingTab";
import { INTRAORAL_MASTERS } from "./intraoralFindingForm";

const IntraoralFindingMaster = () => {
  const [activeKey, setActiveKey] = useState(INTRAORAL_MASTERS[0].key);
  const [visited, setVisited] = useState(() => new Set([INTRAORAL_MASTERS[0].key]));

  const open = (key) => {
    setActiveKey(key);
    setVisited((prev) => new Set(prev).add(key));
  };

  return (
    <>
      <Box
        role="tablist"
        aria-label="Intraoral Findings"
        sx={{ display: "flex", alignItems: "center", mt: 1, borderBottom: "1px solid #E6EBFF" }}
      >
        {INTRAORAL_MASTERS.map((master) => (
          <Box
            key={master.key}
            component="button"
            type="button"
            role="tab"
            aria-selected={activeKey === master.key}
            onClick={() => open(master.key)}
            sx={{
              border: "none",
              background: "transparent",
              borderBottom:
                activeKey === master.key ? "2px solid #194AF5" : "2px solid transparent",
              color: activeKey === master.key ? "#194AF5" : "#7D8DC4",
              padding: "0.5rem 1rem",
              fontWeight: 600,
              fontSize: "0.875rem",
              cursor: "pointer",
            }}
          >
            {master.label}
          </Box>
        ))}
      </Box>

      {INTRAORAL_MASTERS.filter((master) => visited.has(master.key)).map((master) => (
        <Box
          key={master.key}
          role="tabpanel"
          aria-label={master.label}
          hidden={activeKey !== master.key}
        >
          <IntraoralFindingTab master={master} />
        </Box>
      ))}
    </>
  );
};

export default IntraoralFindingMaster;
